import { DocList } from "./DocList";
import { LegalUpdated } from "./LegalUpdated";

/** The terms of use of Nabble Suite. Draft pending legal review. */
export function TermsOfUseText(): React.JSX.Element {
  return (
    <>
      <LegalUpdated />
      <p>
        These terms apply to everyone who uses Nabble Suite, the workspace operated by Nabble SpA for the organizations that use it.
        By using the suite you accept them.
      </p>

      <h3>Who may use the suite</h3>
      <p>
        Only people invited by an organization that uses Nabble Suite. Your account is personal: don&apos;t share it or let anyone
        else use it.
      </p>

      <h3>Keeping your access safe</h3>
      <DocList>
        <li>Keep your password, your second factor and your recovery codes private.</li>
        <li>If you think someone else knows them or used your account, change your password and tell your administrator straight away.</li>
      </DocList>

      <h3>Acceptable use</h3>
      <DocList>
        <li>Don&apos;t upload or share illegal content, or content that infringes other people&apos;s rights.</li>
        <li>Don&apos;t try to get around the suite&apos;s security, reach information you weren&apos;t given access to, or disrupt the service.</li>
        <li>Respect your colleagues&apos; personal data: use it only for your work, and only as far as you need to.</li>
      </DocList>

      <h3>Your organization&apos;s content</h3>
      <p>
        What is created in the suite for your organization belongs to your organization. Nabble SpA handles it only to run the
        service.
      </p>

      <h3>Availability</h3>
      <p>
        We work to keep the suite available and secure, but we can&apos;t guarantee it will always work without interruptions or
        errors, beyond what has been agreed with your organization.
      </p>

      <h3>Suspension</h3>
      <p>Access can be suspended or ended if these terms are broken or the suite is misused.</p>

      <h3>Applicable law</h3>
      <p>These terms are governed by the laws of Chile. Any dispute will be heard by the courts of Santiago.</p>

      <h3>Changes to these terms</h3>
      <p>When these terms change, the new version is shown the next time you sign in, and you need to accept it before you continue.</p>
    </>
  );
}
